import type { RoleOption, UseCaseOption } from './types';

export const RECORDING_SURVEY_STORAGE_KEY = 'recordingWelcomeSurveyCompleted';
export const OTHER_TEXT_MAX_LENGTH = 500;

export const ROLE_OPTIONS: readonly RoleOption[] = [
  { id: 'founder', label: 'Founder / co-founder' },
  { id: 'marketing', label: 'Marketing / growth' },
  { id: 'product', label: 'Product manager' },
  { id: 'client_services', label: 'Customer success / support' },
  { id: 'creator', label: 'Content creator - blog, YouTube, own audience' },
  { id: 'other', label: 'Other' },
] as const;

export const USE_CASE_OPTIONS: readonly UseCaseOption[] = [
  { id: 'product_demo', label: 'Product or feature demos for customers' },
  { id: 'internal_demo', label: 'Internal demos (for sales, client services, other teams)' },
  { id: 'customer_ed', label: 'Customer education - Help Center, FAQ, tutorials' },
  { id: 'marketing', label: 'Marketing content - landing pages, social, announcements' },
  { id: 'social', label: 'Personal content - LinkedIn, YouTube, blog' },
  { id: 'training', label: 'Internal training or onboarding' },
] as const;

export const RECORDING_SURVEY_COPY = {
  back: 'Back',
  continue: 'Continue',
  otherPlaceholder: 'Enter a description...',
  role: {
    title: 'What best describes your role?',
    subtitle: "We'll tailor Rask to your workflow.",
  },
  use_case: {
    title: 'What is your primary use case?',
    subtitle: "We'll tailor Rask to your workflow.",
  },
} as const;

export const RECORDING_SURVEY_TEST_IDS = {
  continue: 'recording-welcome-survey-continue',
  modal: 'recording-welcome-survey-modal',
  option: (id: string) => `recording-welcome-survey-option-${id}`,
  otherTextInput: 'recording-welcome-survey-other-text',
} as const;
